import { getCookie } from "cookies-next";

import { AdminRole } from "@/types/common";

import { hasPermission } from "./permission";

/**
 * 관리자 토큰 확인
 */
export const getAdminToken = (): string | undefined => {
  return getCookie("adminToken") as string | undefined;
};

/**
 * 관리자 역할 확인
 */
export const getAdminRole = (): AdminRole | undefined => {
  return getCookie("adminRole") as AdminRole | undefined;
};

/**
 * 관리자 인증 여부 확인
 */
export const isAdminAuthenticated = (): boolean => {
  return !!getAdminToken();
};

/**
 * 관리자 토큰 확인
 */
export const getUserToken = (): string | undefined => {
  return getCookie("token") as string | undefined;
};

/**
 * 사용자 인증 여부 확인
 */
export const isUserAuthenticated = (): boolean => {
  return !!getUserToken();
};

/**
 * 권한 체크
 */
export const checkAdminRole = (requiredRole: AdminRole): boolean => {
  const adminRole = getAdminRole();
  if (!adminRole) return false;
  return hasPermission(adminRole, requiredRole);
};

/**
 * 인증된 관리자의 리다이렉트 경로 반환
 */
export const getAuthenticatedRedirectPath = (): string => {
  const role = getAdminRole();
  if (role === "SUPER_ADMIN") {
    return "/dashboard";
  }
  return "/partner-quiz-packs/list";
};
